import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  useMediaQuery,
  InputLabel,
  Select,
  OutlinedInput,
  Chip,
  MenuItem,
  ListItemText,
  FormControl,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  Lock,
  EmailOutlined,
} from "@mui/icons-material";
import imgPanel from "../../../images/bsnl-logo-png.png";
import { styled } from "@mui/system";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Container = styled(Box)({
  width: "100vw",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#f4f4f4",
  padding: "1rem",
});

const AuthWrapper = styled(Box)(({ isMobile }) => ({
  width: isMobile ? "100%" : "1400px",
  height: isMobile ? "auto" : "700px",
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  borderRadius: "12px",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  background: "#fff",
}));

const IllustrationPanel = styled(Box)(({ isSignup, isMobile }) => ({
  width: isMobile ? "100%" : "60%",
  height: isMobile ? "250px" : "100%",
  background: "linear-gradient(135deg,rgb(250, 223, 186), #997d3d)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  color: "#fff",
  padding: "2rem",
  position: isMobile ? "relative" : "absolute",
  top: 0,
  left: isSignup ? (isMobile ? "0%" : "40%") : "0%",
  transition: "left 0.6s ease-in-out",
  textAlign: "center",
}));

const FormPanel = styled(Box)(({ isSignup, isMobile }) => ({
  width: isMobile ? "100%" : "40%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "2rem",
  position: isMobile ? "relative" : "absolute",
  top: 0,
  left: isSignup ? (isMobile ? "0%" : "0%") : isMobile ? "0%" : "60%",
  transition: "left 0.6s ease-in-out",
}));

const StyledForm = styled("form")({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  width: "100%",
  maxWidth: "350px",
  textAlign: "center",
});

const AuthSystem = () => {
  const [isSignup, setIsSignup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    fullName: "",
    terms: false,
  });

  const isMobile = useMediaQuery("(max-width: 768px)");
  const [circles, setCircles] = useState([]);
  const [selectedCircles, setSelectedCircles] = useState([]);
  const [userRole, setuserRole] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [emaillog, setEmailLog] = useState("");
  const [passwordlog, setPasswordLog] = useState("");
  const navigate = useNavigate();
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  useEffect(() => {
    const unauthorizedRedirect = sessionStorage.getItem("unauthorizedRedirect");

    if (unauthorizedRedirect) {
      toast.error("You are not authorized to access this page. Please login.");
      sessionStorage.removeItem("unauthorizedRedirect"); // Clear the flag
    }
  }, []);
  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    const lastPage = sessionStorage.getItem("lastVisitedPage");

    if (userData) {
      navigate(lastPage || "/dashboard");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchCircles = async () => {
      try {
        const response = await fetch(
          "https://api.bharatnet.sunshineiotronics.com/api/v2/circles"
        );
        const data = await response.json();
        setCircles(data);
      } catch (error) {
        toast.error("Failed to fetch circles");
      }
    };

    fetchCircles();
  }, []);
  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "terms" ? checked : value,
    }));
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(!emailRegex.test(e.target.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Validation checks
    if (emailError || !email.trim()) {
      toast.error("Please enter a valid email address.");
      return;
    }
    if (!password.trim()) {
      toast.error("Please enter a password.");
      return;
    }
    if (!userRole.trim()) {
      toast.error("Please select a user role.");
      return;
    }

    // Prepare the payload
    const payload = {
      email: email,
      password: password,
      circles: selectedCircles,
      role: parseInt(userRole),
      is_approved: false,
    };

    console.log(selectedCircles);

    try {
      const response = await fetch(
        "https://api.bharatnet.sunshineiotronics.com/api/v2/auth/signup",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        const data = await response.json();
        toast.success("Account created successfully!");
        setIsSignup(false); // Toggle to sign-in form after successful sign-up
        // Clear input fields
        setEmail("");
        setPassword("");
        setSelectedCircles([]);
        setuserRole("");
      } else {
        const errorData = await response.json();
        toast.error(`${errorData.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again later.");
    }
  };
  const handleSubmitLogin = async (e) => {
    e.preventDefault();

    // Validate email and password
    if (emailError || !email || !passwordlog) {
      toast.error("Please fill out the form correctly!");
      return;
    }

    try {
      const response = await fetch(
        "https://api.bharatnet.sunshineiotronics.com/api/v2/auth/signin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password: passwordlog }),
        }
      );

      if (!response.ok) {
        toast.error("Failed to login. Please try again.");
        return;
      }

      const data = await response.json();

      if (data.is_approved) {
        const userDetails = {
          email: data.email,
          role: data.role,
          circles: data.circles,
        };
        const userCircles = {
          circles: data.circles,
        };
        sessionStorage.setItem("userCircles", JSON.stringify(userCircles));
        sessionStorage.setItem("userDetails", JSON.stringify(userDetails));
        sessionStorage.setItem("userData", JSON.stringify(data)); // Save user details

        // Show success message and navigate
        toast.success("Login Successful! Redirecting...");
        setTimeout(() => {
          navigate("/dashboard", {
            state: { email: data.email, role: data.role },
          });
        }, 500); // Redirect after showing success message
        // Clear input fields
        setEmail("");
        setPasswordLog("");
      } else {
        toast.error("User is not approved to login.");
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };
  return (
    <Container>
      <AuthWrapper isMobile={isMobile}>
        <IllustrationPanel isSignup={isSignup} isMobile={isMobile}>
          <img
            src={imgPanel}
            alt="BharatNet Logo"
            style={{
              width: isMobile ? "30%" : "50%",
              maxWidth: "400px",
              height: "auto",
            }}
          />

          <Typography variant="h2" sx={{ fontWeight: "bold" }}>
            Welcome to BharatNet
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Connecting Bharat, Transforming India
          </Typography>
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => setIsSignup(!isSignup)}
          >
            {isSignup
              ? "Already have an account? Sign In"
              : "Create an account"}
          </Button>
        </IllustrationPanel>

        {/* Sign In Form */}
        <FormPanel isSignup={isSignup} isMobile={isMobile}>
          {!isSignup && (
            <StyledForm onSubmit={handleSubmitLogin}>
              <Typography variant="h5" align="center">
                Sign In
              </Typography>
              <TextField
                fullWidth
                margin="normal"
                label="Email Address"
                variant="outlined"
                value={email}
                onChange={handleEmailChange}
                error={emailError}
                helperText={emailError ? "Enter a valid email address" : ""}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" className="icon-container">
                      <EmailOutlined className="icon" />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                margin="normal"
                label="Password"
                type={showPassword ? "text" : "password"}
                minLength="8"
                variant="outlined"
                value={passwordlog}
                onChange={(e) => setPasswordLog(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" className="icon-container">
                      <Lock className="icon" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={togglePasswordVisibility}
                        edge="end"
                        className="eye-button"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button fullWidth variant="outlined" type="submit">
                Sign In
              </Button>
            </StyledForm>
          )}

          {/* Sign Up Form */}
          {isSignup && (
            <StyledForm onSubmit={handleSubmit} autoComplete="off">
              <Typography variant="h5" align="center">
                Sign Up
              </Typography>
              <TextField
                fullWidth
                margin="normal"
                label="Email Address"
                variant="outlined"
                value={email}
                onChange={handleEmailChange}
                autoComplete="off"
                error={emailError}
                helperText={emailError ? "Enter a valid email address" : ""}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" className="icon-container">
                      <EmailOutlined className="icon" />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                margin="normal"
                label="Password"
                minLength="8"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={passwordError}
                helperText={passwordError ? "Password is required" : ""}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" className="icon-container">
                      <Lock className="icon" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={togglePasswordVisibility}
                        edge="end"
                        className="eye-button"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <FormControl fullWidth variant="outlined" margin="normal">
                <InputLabel id="multiple-checkbox-label">
                  Select Circles
                </InputLabel>
                <Select
                  labelId="multiple-checkbox-label"
                  id="multiple-checkbox"
                  multiple
                  value={selectedCircles}
                  input={<OutlinedInput label="Select Circles" />}
                  onChange={(e) => setSelectedCircles(e.target.value)}
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                      {selected.map((value) => (
                        <Chip key={value} label={value} sx={{ margin: 0.5 }} />
                      ))}
                    </Box>
                  )}
                >
                  {circles.map((circle, index) => (
                    <MenuItem key={index} value={circle.state}>
                      <Checkbox
                        checked={selectedCircles.indexOf(circle.state) > -1}
                      />
                      <ListItemText primary={circle.state} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth variant="outlined" margin="normal">
                <InputLabel id="confirm-password-label">User Role</InputLabel>
                <Select
                  labelId="confirm-password-label"
                  id="user-role"
                  value={userRole}
                  name="userRole"
                  displayEmpty
                  onChange={(e) => setuserRole(e.target.value)}
                  label="User Role"
                >
                  <MenuItem value="4">Super Admin</MenuItem>
                  <MenuItem value="3">Admin</MenuItem>
                  <MenuItem value="2">Configuration Manager</MenuItem>
                  <MenuItem value="1">Operator</MenuItem>
                </Select>
              </FormControl>

              <Button
                fullWidth
                variant="contained"
                className="signup-button"
                type="submit"
              >
                Sign Up
              </Button>
            </StyledForm>
          )}
        </FormPanel>
      </AuthWrapper>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Container>
  );
};

export default AuthSystem;
